import EditarCriativo from "../../../components/Cadastros/Editar/EditarCriativo";
import Header from "../../../components/Menu";

const EditarCriativoPage = () => {
  return (
    <div className="flex">
      <Header />
      <EditarCriativo />
    </div>
  );
};

export default EditarCriativoPage;
